const initialState = {
  version: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_VERSION':
      return { ...state, version: action.version };
    default:
      return state;
  }
};
